export default "__VITE_ASSET__BqBMg6tJ__"